import React, { Component } from "react";
import "./DeleteExitModal.css";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default class RemoveModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleChange = (e) => {
    let { name, value } = e.target;
    const activeItem = { ...this.state.activeItem, [name]: value };
    this.setState({ activeItem });
  };

  render() {
    const {
      toggle,
      toggleName,
      onSave,
      message_body,
      message_header,
      saveButton,
    } = this.props;

    return (
      <Modal
        modalClassName="Modal"
        isOpen={true}
        toggle={function () {
          return toggle(toggleName);
        }}
      >
        <ModalHeader>
          {" "}
          {message_header}{" "}
          <button
            className="exit_close_button"
            onClick={function () {
              return toggle(toggleName);
            }}
          >
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          {message_body}
          {saveButton !== "" ? (
            <div className="button_area">
              <button
                disabled={this.state.loading}
                className={`delete_button ${saveButton}`}
                onClick={async() => {
                  this.setState({loading: true})
                  await onSave();
                  this.setState({loading: false})
                }}
              >
                {this.state.loading ? "Loading..." : saveButton }
              </button>
            </div>
          ) : null}
        </ModalBody>
      </Modal>
    );
  }
}
